import axiosClient from 'utils/axiosClient';
import api from 'api';

const getDictionary = async (dict: string, role: 'STUDENT' | 'CANDIDATE') => {
	const API = api[role];

	const response = await axiosClient.get(API.SETTINGS.DICT + `/${dict}`);
	return response.data;
};

interface DictionaryType {
	id: number;
	name: string;
	status: number;
	isTrigger: 0 | 1;
	creationDate: string;
	lastModifiedDate: string;
}

const fetchOptions = async (dictionary: string, role: 'STUDENT' | 'CANDIDATE'): Promise<DictionaryType[]> => {
	const API = api[role];

	const response = await axiosClient.get(API.SETTINGS.DICT + dictionary);
	return response.data.data;
};

const getByCustomPath = async (path: string): Promise<any> => {
	const response = await axiosClient.get(path);
	return response.data.data || response.data;
};

const service = {
	getDictionary,
	fetchOptions,
	getByCustomPath
};

export default service;
